import { Controller } from 'stimulus'

// Balances a 2-column CSS grid (grid-auto-flow: column) by counting
// rendered .form-group elements and setting the row count to half.
// Uses a timeout to wait for React components to render.
export default class extends Controller {
  connect() {
    setTimeout(() => {
      let count = 0
      for (const child of this.element.children) {
        const display = getComputedStyle(child).display
        if (display === 'none') continue
        // display: contents elements (e.g. asset select) are flattened,
        // so count their .form-group children as grid items
        if (display === 'contents') {
          count += child.querySelectorAll('.form-group').length
        } else {
          count++
        }
      }
      const rows = Math.ceil(count / 2)
      this.element.style.gridTemplateRows = `repeat(${rows}, auto)`
    }, 200)
  }
}
